import { fetchMainQueryLanding } from '@/components/reusable/mainQueriesLandings/reusable/_helpers/fetchData';
import AllCottage from '@/components/allCottage/AllCottage';
import { getUserAgent } from '@/helpers/userAgent';
import SEOMetaData from '@/components/reusable/mainQueriesLandings/reusable/seoMetaData/SEOMetaData';
const perPage = 24;
const Index = ({
  data,
  isBot,
  host
}) => {
  return <>
      <SEOMetaData data={data} perPage={perPage} host={host} pageContent="cottage" data-sentry-element="SEOMetaData" data-sentry-source-file="index.tsx" />
      <AllCottage firstData={data} isBot={isBot} data-sentry-element="AllCottage" data-sentry-source-file="index.tsx" />
    </>;
};
export default Index;
export const getServerSideProps = async ctx => {
  const ua = getUserAgent(ctx.req);
  const host = 'https://' + ctx.req.headers.host;
  if (process.env.OFFLINE_MODE === 'true') {
    const {
      offlineCottageProps
    } = await import('@/helpers/offline/snapshot');
    return offlineCottageProps(ctx, ua);
  }
  const data = await fetchMainQueryLanding({
    query: ctx.query,
    req: ctx.req,
    perPage,
    pageContent: 'cottage'
  });
  return {
    props: {
      data,
      isBot: true,
      host,
      ua
    }
  };
};